export function dataInRequest(params = {}) {
  return {
    type: '@distribuidora/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@distribuidora/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@distribuidora/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@distribuidora/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@distribuidora/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@distribuidora/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@distribuidora/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@distribuidora/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@distribuidora/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@distribuidora/RECORD_FILTERING',
    payload: { params },
  };
}
